import { render, staticRenderFns } from "./DotsList.vue?vue&type=template&id=4571b9cf&"
import script from "./DotsList.vue?vue&type=script&lang=js&"
export * from "./DotsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports